<template>
  <b-row class="fill-width" id="main-row">
    <b-col
      cols="2"
      align-self="center"
      class="d-flex justify-content-center border-left-dashed-2px-light-grey position-relative"
      id="header-img-col"
    >
      <slot name="header">
        <b-container
          class="m-0 p-0"
          :class="{ 'top-bottom-circle': showCircles }"
          fluid
        >
          <HeaderNewVersion />
        </b-container>
      </slot>
    </b-col>
    <b-col
      cols="10"
      align-self="center"
      class="d-flex justify-content-start pl-0"
    >
      <slot name="body"> </slot>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import HeaderNewVersion from "@/components/HeaderNewVersion";
export default {
  name: "DesktopLayoutHelperNewVersion",
  data() {
    return {
      showCircles: true,
    };
  },
  components: { HeaderNewVersion },
  computed: {
    ...mapGetters(["getIsCompName", 'getStepperPage']),
  },
  methods: {
    handleCircleResponsive() {
      const baseContainer = document.querySelector(".base-container");
      const headerImg = document.getElementById("header-img-col");
      // Get the pseudo-elements
      const circles = document.querySelector(".top-bottom-circle");
      // Get the width of the element
      const headerImgWidth = headerImg.offsetWidth;
      const headerImgHeight = headerImg.offsetHeight;
      const baseContainerHeight = baseContainer.offsetHeight;
      const rightValue = headerImgWidth - 17.5 + "px";
      //17.5 is the half of height of the circles.
      const yDisValue =
        (baseContainerHeight - headerImgHeight) / 2 + 17.5 + "px";
      circles.style.setProperty("--right-before", rightValue);
      circles.style.setProperty("--right-after", rightValue);
      circles.style.setProperty("--top-after", "-" + yDisValue);
      circles.style.setProperty("--bottom-before", "-" + yDisValue);

    },
  },
  watch: {
    getIsCompName() {
      this.showCircles = false;
      this.$nextTick(() => {
        this.showCircles = true;
      });
    },
    getStepperPage(){
      setTimeout(() => {
        this.handleCircleResponsive();
      }, 50);
    }
  },
  mounted() {
    // Call handleCircleResponsive initially
    this.handleCircleResponsive();

    // Set a timeout for the second call with a delay (e.g., 500 milliseconds)
    setTimeout(() => {
      this.handleCircleResponsive();
    }, 50);
    window.addEventListener("resize", this.handleCircleResponsive);

  },
  beforeDestroy() {
    // Remove event listener to prevent memory leaks
    window.removeEventListener("resize", this.handleCircleResponsive);
  },
};
</script>

<style scoped>
.top-bottom-circle::before {
  right: var(--right-before, 0);
  bottom: var(--bottom-before, 0);
}

.top-bottom-circle::after {
  right: var(--right-after, 0);
  top: var(--top-after, 0);
}
.top-bottom-circle::after {
  opacity: 0.95;
  content: "";
  position: absolute;
  /*background: var(--new-version-main-background);*/
  background: #efefef;
  /*background: red;*/
  width: 35px;
  height: 35px;
  border-radius: 50%;
}
.top-bottom-circle::before {
  opacity: 0.95;
  content: "";
  position: absolute;
  background: #ede9e9;

  /*background: var(--new-version-main-background);*/
  /*background: red;*/
  width: 35px;
  height: 35px;
  border-radius: 50%;
}
/*@media (max-width: 1150px) and (min-height: 900px) {*/
/*  .top-bottom-circle::after {*/
/*    top: -26%;*/
/*    left: -13%;*/
/*  }*/
/*  .top-bottom-circle::before {*/
/*    bottom: -26%;*/
/*    left: -13%;*/
/*  }*/
/*}*/
/*@media (min-width: 1151px) and (max-width: 1550px) and (min-height: 900px) {*/
/*  .top-bottom-circle::after {*/
/*    top: -35%;*/
/*    left: -9%;*/
/*  }*/
/*  .top-bottom-circle::before {*/
/*    bottom: -35%;*/
/*    left: -9%;*/
/*  }*/
/*}*/
/*@media (min-width: 1550px) and (min-height: 900px) and (max-height: 1200px) {*/
/*  .top-bottom-circle::after {*/
/*    top: -45%;*/
/*    left: -9%;*/
/*  }*/
/*  .top-bottom-circle::before {*/
/*    bottom: -45%;*/
/*    left: -9%;*/
/*  }*/
/*}*/
/*@media (max-width: 1150px) and (min-height: 1100px) {*/
/*  .top-bottom-circle::after {*/
/*    top: -23%;*/
/*    left: -11%;*/
/*  }*/
/*  .top-bottom-circle::before {*/
/*    bottom: -23%;*/
/*    left: -11%;*/
/*  }*/
/*}*/

/*@media (max-width: 2400px) and (min-height: 1000px) {*/
/*  .top-bottom-circle::after {*/
/*    top: -36%;*/
/*    left: -9%;*/
/*  }*/
/*  .top-bottom-circle::before {*/
/*    bottom: -36%;*/
/*    left: -9%;*/
/*  }*/
/*}*/
/*@media (max-width: 1500px) and (min-height: 1200px) {*/
/*  .top-bottom-circle::after {*/
/*    top: -30%;*/
/*    left: -9%;*/
/*  }*/
/*  .top-bottom-circle::before {*/
/*    bottom: -30%;*/
/*    left: -9%;*/
/*  }*/
/*}*/

/*@media (max-width: 1500px) and (min-height: 1400px) {*/
/*  .top-bottom-circle::after {*/
/*    top: -19%;*/
/*    left: -9%;*/
/*  }*/
/*  .top-bottom-circle::before {*/
/*    bottom: -19%;*/
/*    left: -9%;*/
/*  }*/
/*}*/
/*@media (max-width: 2700px) and (min-width: 1501px) and (min-height: 1400px) {*/
/*  .top-bottom-circle::after {*/
/*    top: -25%;*/
/*    left: -9%;*/
/*  }*/
/*  .top-bottom-circle::before {*/
/*    bottom: -25%;*/
/*    left: -9%;*/
/*  }*/
/*}*/
/*@media (max-width: 1150px) and (min-height: 1400px) {*/
/*  .top-bottom-circle::after {*/
/*    top: -15%;*/
/*    left: -11%;*/
/*  }*/
/*  .top-bottom-circle::before {*/
/*    bottom: -15%;*/
/*    left: -11%;*/
/*  }*/
/*}*/
</style>
